import React, { useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import { Toast } from "discover.medical.react-component-library";
import { showErrorMsg, hideErrorMsg } from "../../store/actions";
import ApiService from "./../../util/ApiService";
import { useDispatch } from "./../../store";

function ErrorMessage({ isErrorMsgShown = false }) {
  const dispatch = useDispatch();
  const hideMessage = () => {
    hideErrorMsg(dispatch);
  };

  const showMessage = useCallback(() => {
    if (!isErrorMsgShown) {
      showErrorMsg(dispatch);
    }
  }, [dispatch, isErrorMsgShown]);

  useEffect(() => {
    ApiService.initErrorHandling(showMessage);
  }, [showMessage]);

  return (
    <div
      onClick={hideMessage}
      data-testid={`error-message-wrap-${isErrorMsgShown}`}
    >
      <Toast
        isOpen={isErrorMsgShown}
        onClose={hideMessage}
        type="error"
        children="Unexpected server error occurred. Please try again later."
      />
    </div>
  );
}

ErrorMessage.propTypes = {
  isErrorMsgShown: PropTypes.bool,
};

export default ErrorMessage;
